import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/client/app";
import { RouterProvider } from "@/client/router";

const element = document.getElementById("root");
if (element === null) throw new Error("orik web: the page has no #root to mount into");

// Each page brings its own stylesheets: the harness's for the signed-in app, Orik's for sign-in (`app.tsx`).
createRoot(element).render(
  <StrictMode>
    <RouterProvider>
      <App />
    </RouterProvider>
  </StrictMode>,
);
